const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3EffectsPlus {
    constructor(runtime) { this.runtime = runtime; }
    getInfo() {
        return {
            id: 'effectsPlus', name: '✨ エフェクト+', color1: '#9966FF', color2: '#774DCB',
            blocks: [
                { opcode: 'setEffect', blockType: BlockType.COMMAND, text: '[E] エフェクトを [V] にする', arguments: { E: { type: ArgumentType.STRING, menu: 'effects', defaultValue: 'brightness' }, V: { type: ArgumentType.NUMBER, defaultValue: 0 } } },
                { opcode: 'changeEffect', blockType: BlockType.COMMAND, text: '[E] エフェクトを [V] ずつ変える', arguments: { E: { type: ArgumentType.STRING, menu: 'effects', defaultValue: 'brightness' }, V: { type: ArgumentType.NUMBER, defaultValue: 10 } } },
                { opcode: 'getEffect', blockType: BlockType.REPORTER, text: '[E] エフェクトの値', arguments: { E: { type: ArgumentType.STRING, menu: 'effects', defaultValue: 'brightness' } } },
                { opcode: 'clearEffects', blockType: BlockType.COMMAND, text: '画像効果をなくす' }
            ],
            menus: { effects: { items: ['color', 'fisheye', 'whirl', 'pixelate', 'mosaic', 'brightness', 'ghost'] } }
        };
    }
    setEffect(args) { var t = this.runtime.getEditingTarget(); if (t) t.setEffect(args.E, Cast.toNumber(args.V)); }
    changeEffect(args) { var t = this.runtime.getEditingTarget(); if (t) t.setEffect(args.E, (t.effects[args.E] || 0) + Cast.toNumber(args.V)); }
    getEffect(args) { var t = this.runtime.getEditingTarget(); return t ? t.effects[args.E] || 0 : 0; }
    clearEffects() { var t = this.runtime.getEditingTarget(); if (t) t.clearEffects(); }
}
module.exports = Scratch3EffectsPlus;